<template lang="pug">
el-dialog(v-dialog-drag, :title="title", top="50px", width="1300px", :visible.sync="show", :close-on-click-modal="false", @close="closeHandler")
  template(#default)
    .content
      el-form.form(ref="ruleForm", :rules="rules", :model="editData", label-position="left", label-width="140px", size="small")
        el-form-item(label="内部名称", prop="tableName")
          el-input(v-model="editData.tableName" maxlength="30" show-word-limit)
          span 提示： 表名必须以z_开头，全部小写且以下划线分隔，表必须全局唯一。
        el-form-item(label="业务模型名称", prop="businessName")
          el-input(v-model="editData.businessName", placeholder="请输入中文名称" maxlength="30" show-word-limit)
        el-form-item(label="描述", prop="tableDesc")
          el-input(v-model="editData.tableDesc", type="textarea", placeholder="请输入中文名称" maxlength="50" show-word-limit)
        el-form-item(label="字段信息", required)
          el-button(type="text", icon="el-icon-circle-plus-outline", @click="addNewField") 新增一行
          el-button(type="text", @click="clearAllFields") 清空
          el-button(type="text", icon="el-icon-circle-plus-outline", @click="addFlowStatusField") 增加流程状态字段
      .table
        vxe-table(
          ref="xTable",
          border,
          round,
          resizable,
          size="medium",
          show-overflow,
          keep-source,
          :edit-rules="validRules",
          :data="editData.columnList",
          height="100%",
          :edit-config="{ trigger: 'click', mode: 'cell', autoClear: false, activeMethod: activeRowMethod }"
        )
          vxe-table-column(title="移动" width="50" align="center")
            i.iconfont.icon-drag.drag-option
          vxe-table-column(field="columnName", title="内部名称", :edit-render="{}")
            template(#edit="{ row }")
              vxe-input(v-model="row.columnName", type="text", placeholder="内部名称")
          vxe-table-column(field="columnDisplayName", title="显示名称", :edit-render="{}")
            template(#edit="{ row }")
              vxe-input(v-model="row.columnDisplayName", type="text", placeholder="显示名称")
          vxe-table-column(field="userTypeName", title="数据类型", :edit-render="{}")
            template(#default="{ row }")
              span(v-if="row.isCustomField === 0") {{ getUserTypeName(row.userTypeName) }}
              span(v-else) {{ getNotTableColumnDataTypeName(row.userTypeName) }}
            template(#edit="{ row }")
              vxe-select(v-if="row.isCustomField === 0", transfer, v-model="row.userTypeName", @change="rowDataTypeChange($event, row)", placeholder="数据类型")
                vxe-option(v-for="item in dataTypeList", :key="item.dicId", :value="item.cnName", :label="item.cnName")
              vxe-select(v-else, v-model="row.userTypeName", transfer, @change="rowDataTypeChange($event, row)", placeholder="数据类型")
                vxe-option(v-for="item in notTableColumnDataType", :key="item.dicId", :value="item.cnName", :label="item.cnName")
          vxe-table-column(field="maxLength", title="内部长度", :edit-render="{}")
            template(#edit="{ row }")
              vxe-input(v-model="row.maxLength", type="text", placeholder="内部长度")
          vxe-table-column(field="displayDataType", title="控件", :edit-render="{}")
            template(#default="{ row }")
              span {{ getWidgetTypeName(row.displayDataType) }}
            template(#edit="{ row }")
              vxe-select(v-model="row.displayDataType", clearable, placeholder="控件类型")
                vxe-option(v-for="item in widgetTypeList", :key="item.dicId", :value="item.enName", :label="item.cnName")
          vxe-table-column(field="defaultValue", title="默认值", :edit-render="{}")
            template(#edit="{ row }")
              vxe-input(v-model="row.defaultValue", placeholder="默认值")
          vxe-column(field="isInternalField", align="center", title="内部字段", v-slot="{ row, rowIndex }")
            vxe-checkbox(v-model="row.isInternalField", :checked-value="1", :unchecked-value="0", :disabled="!row.canEdit")
          vxe-table-column(field="isNullable", title="必填", align="center", v-slot="{ row, rowIndex }")
            vxe-checkbox(v-model="row.isNullable", size="small", :checked-value="0", :unchecked-value="1", :disabled="!row.canEdit")
          vxe-table-column(field="remark", title="备注", :edit-render="{}")
            template(#edit="{ row }")
              vxe-input(v-model="row.remark", type="text", size="medium", placeholder="备注")
          vxe-table-column(field="", title="操作", width="60px")
            template(#default="{ row, rowIndex }")
              el-button(type="text", v-if="row.canEdit", @click="deleteRow(row, rowIndex)") 删除
  template(#footer)
    div
      .right
        el-button(size="small", @click="close") 取消
        el-button(type="primary", size="small", @click="saveHandler") 保存
</template>

<script>
import metadataService from "@/CommonDP/service/metadata-service.js";
import dicService from "@/CommonDP/service/dic-service.js";
import { getValueByKey } from "@/CommonDP/utils/common";
import Sortable from "sortablejs";
import "@/CommonDP/utils/vxe-table/index.js";

const MODE = {
  ADD: "add",
  EDIT: "edit",
  COPY: "copy"
};
const TITLE = {
  ADD: "新建业务模型",
  EDIT: "维护业务模型"
};
const TYPE = {
  VARCHAR: "varchar",
  DATETIME: "datetime",
  TINYINT: "tinyint"
};
const WIDGET_TYPE = {
  INPUT: "input",
  DATETIME: "timePicker"
};
// 标准类型常量
const STD = {
  UNI_ID: "S0000",
  CREATE_USER_ID: "S0003",
  CREATE_TIME: "S0005",
  UPDATE_USER_ID: "S0006",
  UPDATE_TIME: "S0008",
  IS_DELETE: "S0010",
  ENTERPRISE_ID: "S0001",
  FLOW_STATUS: "flowStatus",
  FLOW_STATUS_NAME: "flowStatusName"
};
export default {
  name: "ModelMaintain",
  props: {},
  data() {
    return {
      show: false,
      title: "",
      MODE,
      mode: "", // 组件模式，
      nodeData: {},
      editData: this.createEditData(),
      tableData: [],
      dataTypeList: [],
      notTableColumnDataType: [],
      widgetTypeList: [],
      standardTypeList: [],
      rules: {
        tableName: [{ validator: this.validatePass, required: true, trigger: "blur" }],
        businessName: [{ required: true, message: "请输入业务模型名称", trigger: "blur" }]
      },
      validRules: {
        columnName: [{ required: true, message: "请填写内部名称" }],
        columnDisplayName: [{ required: true, message: "请填写显示名称" }],
        userTypeName: [{ required: true, message: "请选择数据类型" }],
        maxLength: [{ required: false, message: "请填写长度" }],
        displayDataType: [{ required: true, message: "请选择显示控件" }],
        defaultValue: [{ required: false, message: "请填写默认值" }],
        stdFieldType: [{ required: false, message: "请选择标准字段" }]
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入内部名称"));
      } else if (/[A-Z]/g.test(value)) {
        callback(new Error("不允许出现大写字母！"));
      } else {
        callback();
      }
    },
    openDialog(nodeData, editData = null, type) {
      this.initDict();
      this.show = true;
      this.nodeData = nodeData;
      if (editData) {
        if (this.openType === this.MODE.COPY) {
          this.mode = this.MODE.COPY;
          this.title = TITLE.ADD;
        } else {
          this.mode = this.MODE.EDIT;
          this.title = TITLE.EDIT;
        }
        this.setEditData(editData);
      } else {
        this.mode = this.MODE.ADD;
        this.title = TITLE.ADD;
      }
      this.$forceUpdate();
      this.$nextTick(() => {
        this.resetForm();
        this.pullSort(); // 声明表格拖动排序方法
      });
      this.editData = this.createEditData();
    },
    createEditData() {
      const obj = {
        tableName: "z_",
        businessName: "",
        tableDesc: "",
        columnList: []
      };
      // id（id varchar 32  ）
      // 创建人（creatUserId varchar 32  ）
      // 创建时间(createTime)
      // 修改人（updateUserId）
      // 修改人时间 (updateTime)
      // 是否删除（isDelete tinyint 备注 0未删除 1已删除  默认0）
      // 企业ID （enterpriseId varchar 32）
      const row_id = this.createField({
        columnName: "id",
        columnDisplayName: "主键",
        canDelete: false,
        userTypeName: TYPE.VARCHAR,
        displayDataType: WIDGET_TYPE.INPUT,
        maxLength: 32,
        displayDataLength: 32,
        stdFieldType: STD.UNI_ID,
        isUniqueKey: 1,
        isInternalField: 1
      });
      obj.columnList.push(row_id);

      const row_createUserId = this.createField({
        columnName: "createUserId",
        columnDisplayName: "创建人",
        canDelete: false,
        userTypeName: TYPE.VARCHAR,
        maxLength: 32,
        displayDataLength: 32,
        displayDataType: WIDGET_TYPE.INPUT,
        stdFieldType: STD.CREATE_USER_ID,
        isInternalField: 1
      });
      obj.columnList.push(row_createUserId);

      const row_createUserName = this.createField({
        columnName: "createUserName",
        columnDisplayName: "创建人名称",
        canDelete: false,
        userTypeName: TYPE.VARCHAR,
        maxLength: 32,
        displayDataLength: 32,
        displayDataType: WIDGET_TYPE.INPUT,
        stdFieldType: STD.CREATE_USER_ID,
        isInternalField: 1
      });
      obj.columnList.push(row_createUserName);

      const row_createTime = this.createField({
        columnName: "createTime",
        columnDisplayName: "创建时间",
        canDelete: false,
        displayDataLength: 32,
        userTypeName: TYPE.DATETIME,
        displayDataType: WIDGET_TYPE.DATETIME,
        stdFieldType: STD.CREATE_TIME,
        isInternalField: 1
      });
      obj.columnList.push(row_createTime);

      const row_updateUserId = this.createField({
        columnName: "updateUserId",
        columnDisplayName: "修改人",
        canDelete: false,
        userTypeName: TYPE.VARCHAR,
        maxLength: 32,
        displayDataLength: 32,
        displayDataType: WIDGET_TYPE.INPUT,
        stdFieldType: STD.UPDATE_USER_ID,
        isInternalField: 1
      });
      obj.columnList.push(row_updateUserId);

      const row_updateUserName = this.createField({
        columnName: "updateUserName",
        columnDisplayName: "修改人名称",
        canDelete: false,
        userTypeName: TYPE.VARCHAR,
        maxLength: 32,
        displayDataLength: 32,
        displayDataType: WIDGET_TYPE.INPUT,
        stdFieldType: STD.UPDATE_USER_ID,
        isInternalField: 1
      });
      obj.columnList.push(row_updateUserName);

      const row_updateTime = this.createField({
        columnName: "updateTime",
        columnDisplayName: "修改时间",
        canDelete: false,
        maxLength: 32,
        displayDataLength: 32,
        userTypeName: TYPE.DATETIME,
        displayDataType: WIDGET_TYPE.DATETIME,
        stdFieldType: STD.UPDATE_TIME,
        isInternalField: 1
      });
      obj.columnList.push(row_updateTime);

      const row_isDelete = this.createField({
        columnName: "enterpriseId",
        columnDisplayName: "企业ID",
        canDelete: false,
        maxLength: 32,
        displayDataLength: 32,
        userTypeName: TYPE.VARCHAR,
        displayDataType: WIDGET_TYPE.INPUT,
        stdFieldType: STD.ENTERPRISE_ID,
        isInternalField: 1
      });
      obj.columnList.push(row_isDelete);

      const row_enterpriseId = this.createField({
        columnName: "isDelete",
        columnDisplayName: "是否删除",
        canDelete: false,
        maxLength: "",
        defaultValue: 0,
        userTypeName: TYPE.TINYINT,
        displayDataType: WIDGET_TYPE.INPUT,
        stdFieldType: STD.IS_DELETE,
        isInternalField: 1
      });
      obj.columnList.push(row_enterpriseId);

      //
      return obj;
    },
    createField(c = {}) {
      // isInternalField 是否内部字段 1 为内部字段 0为外部字段
      return {
        columnName: getValueByKey(c, "columnName"),
        columnDisplayName: getValueByKey(c, "columnDisplayName"),
        userTypeName: getValueByKey(c, "userTypeName", TYPE.VARCHAR),
        maxLength: getValueByKey(c, "maxLength", 32),
        displayDataType: getValueByKey(c, "displayDataType"), // 控件类型
        defaultValue: getValueByKey(c, "defaultValue"),
        stdFieldType: getValueByKey(c, "stdFieldType", undefined), // 标准类型
        isNullable: getValueByKey(c, "isNullable", 0),
        remark: getValueByKey(c, "remark"),
        canDelete: getValueByKey(c, "canDelete", true),
        displayDataLength: getValueByKey(c, "displayDataLength", 32),
        isCustomField: getValueByKey(c, "isCustomField", 0), // 是否表字段
        isInternalField: getValueByKey(c, "isInternalField", 1), // 是否内部字段
        isUniqueKey: getValueByKey(c, "isUniqueKey", 0),
        canEdit: getValueByKey(c, "canEdit", false)
      };
    },

    setEditData(editData) {
      this.editData = editData;
    },
    async initDict() {
      this.initDataTypeDict();
      this.initNotTableColumnDataTypeDict();
      this.initWidgetTypeList();
      this.queryStdFieldTypeList();
    },
    /**
     * 表字段数据类型字典
     * @returns {Promise<void>}
     */
    async initDataTypeDict() {
      const res = await dicService.getDicList("DataType");
      this.dataTypeList = res.data || [];
    },
    /**
     * 非表字段数据类型字典
     * @returns {Promise<void>}
     */
    async initNotTableColumnDataTypeDict() {
      const res = await dicService.getDicList("COLUMNDATATYPE");
      this.notTableColumnDataType = res.data || [];
    },
    /**
     * 控件类型
     * @returns {Promise<void>}
     */
    async initWidgetTypeList() {
      const res = await dicService.queryDicContentByName();
      this.widgetTypeList = res.data || [];
    },
    /**
     * 标准型
     * @returns {Promise<void>}
     */
    async queryStdFieldTypeList() {
      const res = await metadataService.queryStdFieldTypeList();
      this.standardTypeList = res.data || [];
    },
    async clearAllFields() {
      await this.$confirm("是否清除所有字段信息?", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning"
      });
      this.editData.columnList = [this.editData.columnList[0]];
    },
    addNewField() {
      const line = this.createField({
        columnName: `column${Math.floor(Math.random() * 1000)}`,
        columnDisplayName: "新建字段",
        displayDataType: WIDGET_TYPE.INPUT,
        isInternalField: 0,
        canEdit: true
      });

      this.editData.columnList.push(line);
    },
    addFlowStatusField() {
      const exists = this.editData.columnList.some((item) => item.columnName === "flowStatus");
      if (exists) {
        this.$error("已经存在名为 flowStatus 的字段");
        return;
      }
      const line = this.createField({
        columnName: `flowStatus`,
        columnDisplayName: "审批状态",
        displayDataType: WIDGET_TYPE.INPUT,
        isInternalField: 1,
        stdFieldType: STD.FLOW_STATUS,
        canEdit: false
      });
      this.editData.columnList.push(line);
      const flowStatusName = this.createField({
        columnName: `flowStatusName`,
        columnDisplayName: "审批状态",
        displayDataType: WIDGET_TYPE.INPUT,
        isInternalField: 1,
        stdFieldType: STD.FLOW_STATUS_NAME,
        canEdit: false
      });
      this.editData.columnList.push(flowStatusName);
    },
    activeRowMethod({ row, rowIndex }) {
      return row.canEdit;
    },
    getUserTypeName(cnName) {
      return this.dataTypeList.find((e) => e.cnName === cnName)?.cnName || cnName;
    },
    getNotTableColumnDataTypeName(cnName) {
      return this.notTableColumnDataType.find((e) => e.cnName === cnName)?.cnName || cnName;
    },
    getWidgetTypeName(enName) {
      return this.widgetTypeList.find((e) => e.enName === enName)?.cnName || enName;
    },
    getStrTypeName(stdFieldType) {
      return this.standardTypeList.find((e) => e.stdFieldType === stdFieldType)?.stdFieldName;
    },
    rowDataTypeChange(e, r) {
      const selectOption = this.dataTypeList.find((el) => el.cnName === e.value);
      r.maxLength = selectOption.enName;
      r.displayDataLength = selectOption.enName;
      console.log(e);
      let displayDataType;
      const key = e.value;
      switch (key) {
        case "date":
          displayDataType = "date";
          break;
        case "datetime":
          displayDataType = "time";
          break;
        case "int":
        case "tinyint":
          displayDataType = "number";
          break;
        default:
          displayDataType = "input";
          break;
      }
      r.displayDataType = displayDataType;
    },
    async deleteRow(row, rowIndex) {
      await this.$confirm(`是否删除 ${row.columnDisplayName} 字段信息`, "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning"
      });
      this.editData.columnList.splice(rowIndex, 1);
    },
    async saveHandler() {
      const validate = await this.validate();
      if (validate) {
        this.postData();
      } else {
        console.log("校验未通过");
      }
    },
    async validate() {
      const valid = await this.$refs.ruleForm.validate();
      if (!valid) {
        return false;
      }
      const errMap = await this.$refs.xTable.validate(true);
      if (errMap) {
        return false;
      }
      return true;
    },
    businessValidate() {
      const form = this.editData;
      const err = [];
      if (form.columnList.length > 0) {
        form.columnList.forEach((row) => {
          if (row.displayDataLength > row.maxLength) {
            err.push("字段业务长度不能大于内部长度");
          }
        });
      }
      return err.length > 0 ? err : undefined;
    },
    getBody() {
      const body = {
        ...this.editData,
        columnList: this.editData.columnList.map((item) => ({ ...item, displayDataLength: item.maxLength, isPrimaryKey: item.columnName === "id" ? 1 : 0 })),
        groupId: this.nodeData.groupId
      };
      return body;
    },
    async postData() {
      const postFunction = this.getPostFunction();
      const body = this.getBody();
      await postFunction(body);
      this.$success("保存成功!");
      this.$emit("initTree", body.tableName);
      this.close();
    },
    getPostFunction() {
      if (this.mode === this.MODE.ADD) {
        return metadataService.saveDynMeta;
      }
    },
    async close(e) {
      if (e) {
        await this.$confirm("数据还未保存，确定关闭吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
      }
      this.show = false;
      this.closeHandler();
    },
    closeHandler() {
      this.resetData();
    },
    resetData() {},
    resetForm() {
      this.$refs.ruleForm.clearValidate();
      this.$refs.xTable.clearValidate();
    },
    // 表格拖动排序方法
    pullSort() {
      // 通过ref获取Dom节点
      const xTable = this.$refs.xTable;
      console.log("xTable", xTable);
      const el = xTable.$el.querySelector(".body--wrapper>.vxe-table--body tbody");
      this.sortable = Sortable.create(el, {
        animation: 200, // 拖拽动画(毫秒)
        handle: ".drag-option",
        setData: function (dataTransfer) {
          dataTransfer.setData("Text", "");
        },
        // 结束拖拽
        onEnd: (e) => {
          // e.oldIndex为拖动一行原来的位置；e.newIndex为拖动后新的位置
          // const oldRow = this.columnList[e.oldIndex]; // 移动元素集合
          // const newRow = this.columnList[e.newIndex]; // 新的元素集合
          // console.log(oldRow, "移动元素集合");
          // console.log(newRow, "新的元素集合");
          // 调用接口传参即可
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.content {
  min-height: 60vh;
  max-height: 80vh;
  overflow: auto;
}

.drag-option {
  cursor: pointer;
}

.table {
  min-height: 50vh;
}

/deep/ .vxe-table--render-default.vxe-editable .vxe-body--column,
.vxe-table--render-default.vxe-editable .vxe-body--column.col--actived {
  padding: 11px 0;
}
</style>
